import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Stack, Tooltip } from '@mui/material'
import type { GridColDef } from '@mui/x-data-grid'
import type { TFunction } from 'i18next'

// Read-only "Activatable" column shared by the schedule resources table and the edit-resources
// drawer. The header label and the Yes/No/Unknown rendering are identical; the tooltip text is
// passed in so each surface explains itself - only the schedule table documents what "Unknown"
// means, since the portfolio-manager-backed drawer always has a concrete boolean (Yes/No) and never
// shows Unknown.
export const getActivatableColumn = <T extends { isActivatable: boolean | null }>(
  t: TFunction,
  helpText: string,
): GridColDef<T> => {
  const label = t('activation_groups.schedules.resources.table.header.is_activatable')

  return {
    field: 'isActivatable',
    headerName: label,
    flex: 1,
    valueGetter: (value: boolean | null | undefined) => {
      if (value == null) return t('common.unknown')
      return value ? t('common.yes') : t('common.no')
    },
    renderHeader: () => (
      <Stack alignItems="center" direction="row" gap={0.5}>
        {label}
        <Tooltip title={helpText}>
          <InfoOutlinedIcon color="action" fontSize="small" sx={{ cursor: 'help' }} />
        </Tooltip>
      </Stack>
    ),
  }
}
